module.exports = __webpack_public_path__ + "img/http-link-icon.9f106cf3.png";